





















































import { Component } from "vue-property-decorator";
import { ErrosService, Detalhe } from "@/services/erros.service";
import DataTable from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import Confirm from "@/shared/components/confirm.vue";
import DatePicker from "@/shared/components/date-picker.vue";
import { dateTimeSeconds } from "@/shared/filters";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";

@Component({
  components: { DataTable, Tooltip, DatePicker, Confirm },
  filters: { dateTimeSeconds },
})
export default class Detalhes extends mixins(GlobalMixin) {
  idErro!: number;
  loading = false;

  retorno: Detalhe = {
    descricao: "",
    detalhe: "",
    pagina: "",
    stackTrace: "",
  };

  mounted() {
    this.idErro = Number(this.$route.params.idErro);
    this.fetchErros();
  }

  async fetchErros() {
    this.loading = true;
    try {
      this.retorno = await ErrosService.Detalhes(this.idErro);
    } finally {
      this.loading = false;
    }
  }

  voltar() {
    this.$router.push({
      name: "erro",
    });
  }
}
